import React from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { Alert } from '../components/Ui/Alert';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #f0f0f0;
`;

const Container = styled.div`
  max-width: 700px;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  background: #fff;

  flex-direction: column;
  justify-content: center;
  align-items: center;
`;


export default function SelfRaiseEyeTicketComplete() {
    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const eyeTicketId = queryParams.get('eyeTicketId');
    const fullName = queryParams.get('fullName') || '';

    return (
        <Wrapper>
            <Container>
                <Alert type="success">
                    Successfully Raised EyeTicket with RX Number: <strong>{eyeTicketId}</strong> for <strong>{fullName}</strong>.
                    <br /><br />
                    Your EyeTicket order has now entered our system and it is awaiting approval, you will recieve a confirmation email shortly. <strong>Please keep a copy of this prescription number.</strong> 
                    <br /><br />
                    <strong>Thank you once again for placing your order with MCR Safety Europe.</strong>
                </Alert>
            </Container>
        </Wrapper>
    );
}